import { render } from "./ChromaticOctave.vue?vue&type=template&id=65194332&scoped=true"
import script from "./ChromaticOctave.vue?vue&type=script&lang=ts"
export * from "./ChromaticOctave.vue?vue&type=script&lang=ts"

import "./ChromaticOctave.vue?vue&type=style&index=0&id=65194332&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-65194332"

export default script